// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Manage_style_wrapper__KpLgb"};